export default "/images/aa4b83207996b71e408ecf6df36d0d51.avif";